import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css'
import { initAdaptive } from './utils/adaptive'
import './assets/css/tailwindcss.css'

// 引入 swiper 的 element bundle
import 'swiper/element/bundle'

// 注册 swiper 的自定义元素
import { register } from 'swiper/element/bundle'
register() // 💥 必须注册！

// 初始化自适应功能
initAdaptive()

createApp(App).use(store).use(router).mount('#app')
